export default __webpack_public_path__ + "static/media/thunderstorm.2c2cfcdb.png";